import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {DataTableHeadCell as RmwcDataTableHeadCell} from '@rmwc/data-table'
import '@rmwc/data-table/styles'

const sharedSortedStyles = css`
  position: relative;
  bottom: 1px;
  font-size: 8px;
`

export const dataTableHeadCellStyles = ({selector = '&&&'}) => css`
  ${selector} {
    font-family: 'Open Sans', sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.1px;
    color: var(--mdc-theme-neutral4);
  }
  ${selector}.rmwc-data-table__head-cell--sortable .rmwc-data-table__sort-icon {
    display: none;
  }
  ${selector}.rmwc-data-table__head-cell--sortable:after {
    padding-left: 6px;
    display: inline-block;
    width: 36px;
    height: 0;
    content: '';
  }
  ${selector}.rmwc-data-table__head-cell--sorted.rmwc-data-table__head-cell--sorted-ascending:after {
    content: '\\25b2';
    ${sharedSortedStyles}
  }
  &&&.rmwc-data-table__head-cell--sorted.rmwc-data-table__head-cell--sorted-descending:after {
    content: '\\25bc';
    ${sharedSortedStyles}
  }
`

const StyledRmwcDataTableHeadCell = styled(RmwcDataTableHeadCell)`
  ${dataTableHeadCellStyles}
`

const DataTableHeadCell = ({children, ...otherProps}) => <StyledRmwcDataTableHeadCell {...otherProps}>{children}</StyledRmwcDataTableHeadCell>

DataTableHeadCell.propTypes = {
  children: PropTypes.any
}

export {DataTableHeadCell}
